module.exports = "https://cdn.realtymogul.com/static/media/merlinIcons.c160fe24.woff";